import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ptBR } from 'date-fns/locale';
import { addDays, getHours, isSameDay, set, startOfDay } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import Loading from 'components/Loading';
import { api } from 'api/api';

const Calendario = (props) => {
  const ENDPOINT =
    process.env.REACT_APP_ENVIRONMENT === 'production'
      ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
      : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

  const backgroundColor = props.backgroundColor;

  const [horariosEmpresa, setHorarioEmpresa] = useState({});
  const [feriadosMock, setFeriadosMock] = useState([]);

  const fetchExecutado = useRef(false);

  const css = `
    .rdp {
      background-color: #F3F3F3;
      padding: 10px;
      border-radius: 5px;
      --rdp-background-color: ${backgroundColor};
      --rdp-accent-color: #C2C6C5;
      color: black;
    }

    .rdp-caption {
      background-color: ${backgroundColor};
      border-radius: 5px;
    }

    .rdp-caption_label {
      color: #FFF
    }

    .rdp-nav_button {
      rotate: 90deg;
    }

    .rdp svg {
      color: #FFF;
    }

    .rdp-day_selected {
      border-radius: 10px;
      color: black;
    }
  `;

  const currentYear = new Date().getFullYear();

  function calcularPascoa(ano) {
    const a = ano % 19;
    const b = Math.floor(ano / 100);
    const c = ano % 100;
    const d = Math.floor(b / 4);
    const e = b % 4;
    const f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const mes = Math.floor((h + l - 7 * m + 114) / 31);
    const dia = ((h + l - 7 * m + 114) % 31) + 1;

    return new Date(ano, mes - 1, dia);
  }

  const pascoa = useMemo(() => calcularPascoa(currentYear), [currentYear]);

  useEffect(() => {
    const feriadosBase = [
      new Date(currentYear, 0, 1),
      new Date(currentYear, 3, 21),
      new Date(currentYear, 4, 1),
      new Date(currentYear, 8, 7),
      new Date(currentYear, 9, 12),
      new Date(currentYear, 10, 2),
      new Date(currentYear, 10, 15),
      new Date(currentYear, 10, 20),
      new Date(currentYear, 11, 25),

      new Date(pascoa.getTime() - 2 * 24 * 60 * 60 * 1000),
      new Date(pascoa.getTime() - 47 * 24 * 60 * 60 * 1000),
      new Date(pascoa.getTime() + 60 * 24 * 60 * 60 * 1000),
    ];

    setFeriadosMock(feriadosBase);
  }, [pascoa, currentYear]);

  const datasDisponiveis = props.datasDisponiveis || [];

  async function fetchDiasEmpresas() {
    try {
      const url = `${ENDPOINT}/appointments/funcionamentoEmpresa/${props?.empresa}`;
      const response = await api(url, {
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        method: 'GET',
      });

      const postsData = await response.json();

      console.log('API feriados:', postsData);

      if (Array.isArray(postsData)) {
        const feriadosAPI = postsData.map((f) => {
          const d = new Date(f.data);
          return new Date(d.getFullYear(), d.getMonth(), d.getDate());
        });

        setFeriadosMock((prev) => [...prev, ...feriadosAPI]);
      }
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    if (!props.empresa) return;
    if (fetchExecutado.current) return;

    fetchExecutado.current = true;
    fetchDiasEmpresas();
  }, [props.empresa]);

  const isFeriado = (date) => {
    return feriadosMock.some((feriado) => isSameDay(feriado, date));
  };

  const estaDataDisponivel = (date) => {
    const hoje = startOfDay(new Date());

    if (isFeriado(date)) return false;

    if (!datasDisponiveis.length) {
      return date >= hoje;
    }

    return datasDisponiveis.some((d) => isSameDay(new Date(d), date)) && date >= hoje;
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: css }} />

      <DayPicker
        defaultMonth={props.date}
        mode="single"
        selected={props.date}
        locale={ptBR}
        onDayClick={(day) => {
          if (estaDataDisponivel(day)) {
            const date = new Date(
              day.getFullYear(),
              day.getMonth(),
              day.getDate(),
              12
            );

            props.setDate(date);
            props.setIsSaturday(day.getDay() === 6);
          }
        }}
        disabled={(day) =>
          !estaDataDisponivel(day) || day.getDay() === 0
        }
      />
    </>
  );
};

export default Calendario;
